import { render, staticRenderFns } from "./AccountingInvoicedDonut.vue?vue&type=template&id=1ffe97c1"
import script from "./AccountingInvoicedDonut.vue?vue&type=script&lang=js"
export * from "./AccountingInvoicedDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports